module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Add Rewards',
        apply: 'Apply',
        cancel: 'Cancel',
        applied: 'Applied',
        remove: 'Remove',
        done: 'Done',
        biPointsText: 'You\'re a',
        with: 'with',
        points: 'points.'
    };

    return resources[label];
};
